import karyogramPlot from "../../../../content/posts/blogs/2021/aplanat/karyogram.jsx";
import * as React from 'react';
export default {
  karyogramPlot,
  React
};